import * as React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import { IItem } from './types';

interface IProps {
    activeItem: IItem;
    reviewHeadingRef: React.RefObject<HTMLDivElement>;
    onBackToList?: () => void;
}

const ReviewHeader = ({ activeItem, reviewHeadingRef, onBackToList }: IProps) => (
    <>
        {onBackToList && (
            <div style={{ marginBottom: 16 }}>
                <Button bsSize='sm' onClick={onBackToList}>
                    <Glyphicon glyph='chevron-left' style={{ marginRight: 6 }} />
                    Back to list
                </Button>
            </div>
        )}
        <div
            ref={reviewHeadingRef}
            tabIndex={-1}
            style={{ marginBottom: 20, paddingBottom: 12, borderBottom: '1px solid #e8e8e8' }}
        >
            <strong>{activeItem.name}</strong>
            <span className='text-muted' style={{ marginLeft: 8 }}>{activeItem.alias}</span>
            <div style={{ marginTop: 6, fontSize: 13 }}>Weeks under review: {activeItem.weeks.join(', ')}</div>
            <p className='text-muted' style={{ marginTop: 10, marginBottom: 0, fontSize: 13, maxWidth: 640 }}>
                Review week history below, then choose <strong>Decision</strong> and <strong>Reason</strong>. If you approve, complete each item in <strong>Additional approval details</strong>, then submit.
            </p>
        </div>
    </>
);

export default ReviewHeader;
